<template>
  <div class="email-client-vdialog">
    <v-row justify="center" class="pregled-poste-wrapper">
      <v-dialog v-model="dialog" width="1250px" style="overflow-y: hidden; overflow-x: hidden">
        <template v-slot:activator="{ on, attrs }">
          <div class="section-square izlazna-posta" v-bind="attrs" v-on="on" @click="addFuckingClass">
            <img class="doc-icon" src="@/assets/img/email_client.svg" />
            <div>{{ $t('components.pregled_poste.fold_1') }}</div>
          </div>
        </template>
        <v-card>
          <div id="email-catcher" class="email-client-header" v-if="selected_attachment == null">
            <div class="header-first-row">
                <div class="post-dropdowns">
                    <div class="posta-dropdown">
                      {{ $t('components.pregled_poste.drop_title') }}:
                      <select id="search-group" v-model="selected_type">
                        <option :value="0">{{ $t('components.pregled_poste.drop_values[0]') }}</option>
                        <option :value="3">{{ $t('components.pregled_poste.drop_values[1]') }}</option>
                        <option :value="1" v-if="spisi.length > 0">{{ $t('components.pregled_poste.drop_values[2]') }}</option>
                        <!-- <option value="2" >Vlastoručno pretraživanje</option> -->
                        <option :value="2">{{ $t('components.pregled_poste.drop_values[3]') }}</option>
                        
                      </select>
                      <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
                    </div>
                    <div class="posta-dropdown limit-page-drop">
                      {{$t("components.pregled_poste.page_number")}}
                      <select id="search-group multiple" class="limit-page-no" v-model="select_page_limit">
                        <option v-for="(lim, key) in page_limits" :key="key" :value="lim.value">{{ lim.name }}
                        </option>
        
                      </select>
                      <!-- <input type="submit" value="Submit" /> -->
                      <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
                    </div>
                </div>
            </div>
            <div class="comm-buttons-wrapper">
              <div class="spis-dropdown-wrapper" v-if="spisi.length > 0">
                <div :class="[ 'button-dodijeli-komunikaciji', dropSpisOpen ? 'active' : '', ]" @click="openSpisDrop()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"> <g> <g> <path d="M29.248 16.733v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17c-1.11-1.232-1.8-2.77-1.8-4.015v-.32l4.494-7.491-4.777-1.896c-.238.231-.515.42-.817.555v16.435h2.912L21.523 30H7.725l2.832-5.664h2.912V7.901a2.846 2.846 0 0 1-.817-.555L7.875 9.241l4.495 7.492v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17C.691 19.836 0 18.298 0 17.053v-.32L5.396 7.74 11.795 5.2a2.84 2.84 0 0 1 1.674-2.47V.751h2.31v1.98a2.84 2.84 0 0 1 1.675 2.47l6.398 2.539zm-2.63 1.475h-7.11a5.697 5.697 0 0 0 1.236 1.674c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.695 5.695 0 0 0 1.235-1.674zm-.565-2.31l-2.99-4.983-2.99 4.982zM17.785 27.69l-.522-1.043h-5.278l-.522 1.043zM14.103 5.316a.522.522 0 1 0 1.044-.001.522.522 0 0 0-1.044.001zM3.866 19.882c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.696 5.696 0 0 0 1.235-1.674H2.63a5.692 5.692 0 0 0 1.236 1.674zm5.309-3.985l-2.99-4.982-2.99 4.982z" /> </g> </g> </svg>
                  <span id="button-text-span-spis" class="button-text-span-spis" style="width: 50.95px">{{ dodaj_spis_text }}</span>
                  <div id="svg-spin-spis" class="svg-spin-wrapper-spis"
                    style="display: none; width: 50.95px;justify-content: center;">
                    <svg class="update-event-spin spinner-spis" id="add-to-spis" style="display: none" viewBox="0 0 50 50"> <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle> </svg>
                  </div>
                  <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
                </div>
                <div class="custom-dropdown-elements-wrapper">
                  <div v-for="spis in spisi" :key="spis.id" class="custom-dropdown-element-wrapper">
                    <div class="custom-dropdown-text">{{ spis.naziv }}</div>
                    <div class="task-checkbox-container" @click="chooseSpis(spis.id)">
                      <div :class="[ 'custom-checkbox', 'popup-check', chosen_spis == spis.id ? 'active' : '', ]">
                        <div class="check"></div>
                      </div>
                    </div>
                  </div>
                  <div class="dropdown-add-button" @click="addToSpis()">
                    {{ $t("components.pregled_poste.add_btn") }}
                  </div>
                </div>
              </div>
              <div :class="[ 'button-dodijeli-komunikaciji', adding_to_ulazna ? 'active' : '', ]" @click="!adding_to_ulazna ? inMailToPDF() : ''">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1888 0H5.03412C4.58608 0 4.22284 0.374616 4.22284 0.836705V3.10904C4.22284 3.57113 4.58608 3.94575 5.03412 3.94575C5.48217 3.94575 5.8454 3.57113 5.8454 3.10904V1.67341H24.3774V17.3219H5.8454V15.8863C5.8454 15.4242 5.48217 15.0496 5.03412 15.0496C4.58608 15.0496 4.22284 15.4242 4.22284 15.8863V18.1586C4.22284 18.6207 4.58608 18.9953 5.03412 18.9953H25.1887C25.6368 18.9953 26 18.6207 26 18.1586V0.836705C26.0001 0.37454 25.6368 0 25.1888 0ZM2.76183 7.32891H6.24029C6.68834 7.32891 7.05157 6.95429 7.05157 6.4922C7.05157 6.03011 6.68834 5.6555 6.24029 5.6555H2.76183C2.31378 5.6555 1.95055 6.03011 1.95055 6.4922C1.95055 6.95429 2.31378 7.32891 2.76183 7.32891ZM6.24028 10.3344H0.811279C0.363232 10.3344 0 9.95977 0 9.49769C0 9.0356 0.363232 8.66098 0.811279 8.66098H6.24028C6.68833 8.66098 7.05156 9.0356 7.05156 9.49769C7.05156 9.95977 6.68833 10.3344 6.24028 10.3344ZM9.41225 13.1879C9.26098 13.1879 9.10809 13.1444 8.97172 13.0532C8.59573 12.8019 8.4885 12.2838 8.73232 11.8961L10.2396 9.49776L8.73232 7.09931C8.48864 6.71154 8.59588 6.19346 8.97187 5.94215C9.34771 5.69076 9.85019 5.80143 10.0939 6.1892L11.6473 8.66113H18.5758L20.1291 6.18928C20.3728 5.80143 20.8751 5.69083 21.2511 5.94215C21.6272 6.19346 21.7344 6.71154 21.4907 7.09931L19.9835 9.49776L21.4907 11.8961C21.7344 12.2838 21.6272 12.802 21.2512 13.0533C20.8751 13.3045 20.3728 13.1939 20.1291 12.8062L18.5758 10.3344H11.6472L10.0938 12.8062C9.93847 13.0533 9.67805 13.1879 9.41225 13.1879ZM6.24029 11.6664C6.68834 11.6664 7.05157 12.041 7.05157 12.5031C7.05157 12.9652 6.68834 13.3398 6.24029 13.3398H2.76183C2.31378 13.3398 1.95055 12.9652 1.95055 12.5031C1.95055 12.041 2.31378 11.6664 2.76183 11.6664H6.24029Z" fill="#342DAB" /> </svg>
                <span id="button-text-span-ulazna" class="button-text-span-ulazna" style="width: 58.56px">{{ dodaj_ulazna_text }}</span>
                <div id="svg-spin-ulazna" class="svg-spin-wrapper-ulazna" style="display: none; width: 58.56px; justify-content: center">
                  <svg class="update-event-spin spinner-ulazna" id="add-to-ulazna" style="display: none" viewBox="0 0 50 50"> <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle> </svg>
                </div>
              </div>
              <div :class="[ 'button-dodijeli-komunikaciji', adding_to_izlazna ? 'active' : '', ]" @click="!adding_to_izlazna ? outMailToPDF() : ''">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1888 0H5.03412C4.58608 0 4.22284 0.374616 4.22284 0.836705V3.10904C4.22284 3.57113 4.58608 3.94575 5.03412 3.94575C5.48217 3.94575 5.8454 3.57113 5.8454 3.10904V1.67341H24.3774V17.3219H5.8454V15.8863C5.8454 15.4242 5.48217 15.0496 5.03412 15.0496C4.58608 15.0496 4.22284 15.4242 4.22284 15.8863V18.1586C4.22284 18.6207 4.58608 18.9953 5.03412 18.9953H25.1887C25.6368 18.9953 26 18.6207 26 18.1586V0.836705C26.0001 0.37454 25.6368 0 25.1888 0ZM2.76183 7.32891H6.24029C6.68834 7.32891 7.05157 6.95429 7.05157 6.4922C7.05157 6.03011 6.68834 5.6555 6.24029 5.6555H2.76183C2.31378 5.6555 1.95055 6.03011 1.95055 6.4922C1.95055 6.95429 2.31378 7.32891 2.76183 7.32891ZM6.24028 10.3344H0.811279C0.363232 10.3344 0 9.95977 0 9.49769C0 9.0356 0.363232 8.66098 0.811279 8.66098H6.24028C6.68833 8.66098 7.05156 9.0356 7.05156 9.49769C7.05156 9.95977 6.68833 10.3344 6.24028 10.3344ZM9.41225 13.1879C9.26098 13.1879 9.10809 13.1444 8.97172 13.0532C8.59573 12.8019 8.4885 12.2838 8.73232 11.8961L10.2396 9.49776L8.73232 7.09931C8.48864 6.71154 8.59588 6.19346 8.97187 5.94215C9.34771 5.69076 9.85019 5.80143 10.0939 6.1892L11.6473 8.66113H18.5758L20.1291 6.18928C20.3728 5.80143 20.8751 5.69083 21.2511 5.94215C21.6272 6.19346 21.7344 6.71154 21.4907 7.09931L19.9835 9.49776L21.4907 11.8961C21.7344 12.2838 21.6272 12.802 21.2512 13.0533C20.8751 13.3045 20.3728 13.1939 20.1291 12.8062L18.5758 10.3344H11.6472L10.0938 12.8062C9.93847 13.0533 9.67805 13.1879 9.41225 13.1879ZM6.24029 11.6664C6.68834 11.6664 7.05157 12.041 7.05157 12.5031C7.05157 12.9652 6.68834 13.3398 6.24029 13.3398H2.76183C2.31378 13.3398 1.95055 12.9652 1.95055 12.5031C1.95055 12.041 2.31378 11.6664 2.76183 11.6664H6.24029Z" fill="#342DAB" /> </svg>
                <span id="button-text-span-izlazna" class="button-text-span-izlazna" style="width: 60.26px">{{
                  dodaj_izlazna_text
                }}</span>
                <div id="svg-spin-izlazna" class="svg-spin-wrapper-izlazna"
                  style="display: none; width: 60.26px; justify-content: center">
                  <svg class="update-event-spin spinner-izlazna" id="add-to-izlazna" style="display: none" viewBox="0 0 50 50"> <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle> </svg>
                </div>
              </div>
              <div :class="[ 'button-dodijeli-komunikaciji', adding_to_radni ? 'active' : '', ]" @click="!adding_to_izlazna ? radniMailToPDF() : ''">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1888 0H5.03412C4.58608 0 4.22284 0.374616 4.22284 0.836705V3.10904C4.22284 3.57113 4.58608 3.94575 5.03412 3.94575C5.48217 3.94575 5.8454 3.57113 5.8454 3.10904V1.67341H24.3774V17.3219H5.8454V15.8863C5.8454 15.4242 5.48217 15.0496 5.03412 15.0496C4.58608 15.0496 4.22284 15.4242 4.22284 15.8863V18.1586C4.22284 18.6207 4.58608 18.9953 5.03412 18.9953H25.1887C25.6368 18.9953 26 18.6207 26 18.1586V0.836705C26.0001 0.37454 25.6368 0 25.1888 0ZM2.76183 7.32891H6.24029C6.68834 7.32891 7.05157 6.95429 7.05157 6.4922C7.05157 6.03011 6.68834 5.6555 6.24029 5.6555H2.76183C2.31378 5.6555 1.95055 6.03011 1.95055 6.4922C1.95055 6.95429 2.31378 7.32891 2.76183 7.32891ZM6.24028 10.3344H0.811279C0.363232 10.3344 0 9.95977 0 9.49769C0 9.0356 0.363232 8.66098 0.811279 8.66098H6.24028C6.68833 8.66098 7.05156 9.0356 7.05156 9.49769C7.05156 9.95977 6.68833 10.3344 6.24028 10.3344ZM9.41225 13.1879C9.26098 13.1879 9.10809 13.1444 8.97172 13.0532C8.59573 12.8019 8.4885 12.2838 8.73232 11.8961L10.2396 9.49776L8.73232 7.09931C8.48864 6.71154 8.59588 6.19346 8.97187 5.94215C9.34771 5.69076 9.85019 5.80143 10.0939 6.1892L11.6473 8.66113H18.5758L20.1291 6.18928C20.3728 5.80143 20.8751 5.69083 21.2511 5.94215C21.6272 6.19346 21.7344 6.71154 21.4907 7.09931L19.9835 9.49776L21.4907 11.8961C21.7344 12.2838 21.6272 12.802 21.2512 13.0533C20.8751 13.3045 20.3728 13.1939 20.1291 12.8062L18.5758 10.3344H11.6472L10.0938 12.8062C9.93847 13.0533 9.67805 13.1879 9.41225 13.1879ZM6.24029 11.6664C6.68834 11.6664 7.05157 12.041 7.05157 12.5031C7.05157 12.9652 6.68834 13.3398 6.24029 13.3398H2.76183C2.31378 13.3398 1.95055 12.9652 1.95055 12.5031C1.95055 12.041 2.31378 11.6664 2.76183 11.6664H6.24029Z" fill="#342DAB" /> </svg>
                <span id="button-text-span-radni-email" class="button-text-span-izlazna" style="width: 60.26px">{{ dodaj_radna_text }}</span>
                <div id="svg-spin-radni-email" class="svg-spin-wrapper-izlazna" style="display: none; width: 60.26px; justify-content: center">
                  <svg class="update-event-spin spinner-radni-email" id="add-to-radni-email" style="display: none" viewBox="0 0 50 50"> <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle> </svg>
                </div>
              </div>
            </div>
          </div>
          <div id="email-catcher" class="email-client-header" v-else>
            <div class="header-left-wrapper">
              <div class="case-name email-client-title">{{$t('components.pregled_poste.document_title', {docname : selected_attachment.name})}} </div>
            </div>
            <div class="comm-buttons-wrapper">
              <div class="spis-dropdown-wrapper" v-if="isFilePdf() && spisi.length > 0">
                <div :class="[ 'button-dodijeli-komunikaciji', dropSpisOpen ? 'active' : '', ]" @click="openSpisDrop()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"> <g> <g> <path d="M29.248 16.733v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17c-1.11-1.232-1.8-2.77-1.8-4.015v-.32l4.494-7.491-4.777-1.896c-.238.231-.515.42-.817.555v16.435h2.912L21.523 30H7.725l2.832-5.664h2.912V7.901a2.846 2.846 0 0 1-.817-.555L7.875 9.241l4.495 7.492v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17C.691 19.836 0 18.298 0 17.053v-.32L5.396 7.74 11.795 5.2a2.84 2.84 0 0 1 1.674-2.47V.751h2.31v1.98a2.84 2.84 0 0 1 1.675 2.47l6.398 2.539zm-2.63 1.475h-7.11a5.697 5.697 0 0 0 1.236 1.674c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.695 5.695 0 0 0 1.235-1.674zm-.565-2.31l-2.99-4.983-2.99 4.982zM17.785 27.69l-.522-1.043h-5.278l-.522 1.043zM14.103 5.316a.522.522 0 1 0 1.044-.001.522.522 0 0 0-1.044.001zM3.866 19.882c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.696 5.696 0 0 0 1.235-1.674H2.63a5.692 5.692 0 0 0 1.236 1.674zm5.309-3.985l-2.99-4.982-2.99 4.982z" /> </g> </g> </svg>
                  <span id="button-text-span-spis" class="button-text-span-spis" style="width: 50.95px">{{ dodaj_spis_text }}</span>
                  <div id="svg-spin-spis" class="svg-spin-wrapper-spis" style="display: none;width: 50.95px;justify-content: center;">
                    <svg class="update-event-spin spinner-spis" id="add-to-spis" style="display: none" viewBox="0 0 50 50"> <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle> </svg>
                  </div>
                  <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
                </div>
                <div class="custom-dropdown-elements-wrapper">
                  <div v-for="spis in spisi" :key="spis.id" class="custom-dropdown-element-wrapper">
                    <div class="custom-dropdown-text">{{ spis.naziv }}</div>
                    <div class="task-checkbox-container" @click="chooseSpis(spis.id)">
                      <div :class="[ 'custom-checkbox', 'popup-check', chosen_spis == spis.id ? 'active' : '', ]">
                        <div class="check"></div>
                      </div>
                    </div>
                  </div>
                  <div class="dropdown-add-button" @click="addAttachmentToSpis()">
                    {{ $t("components.pregled_poste.add_btn") }}
                  </div>
                </div>
              </div>
              <div v-if="isFilePdf()" :class="[ 'button-dodijeli-komunikaciji', adding_to_ulazna ? 'active' : '', ]" @click="!adding_to_ulazna ? inAttachmentToPDF() : ''">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1888 0H5.03412C4.58608 0 4.22284 0.374616 4.22284 0.836705V3.10904C4.22284 3.57113 4.58608 3.94575 5.03412 3.94575C5.48217 3.94575 5.8454 3.57113 5.8454 3.10904V1.67341H24.3774V17.3219H5.8454V15.8863C5.8454 15.4242 5.48217 15.0496 5.03412 15.0496C4.58608 15.0496 4.22284 15.4242 4.22284 15.8863V18.1586C4.22284 18.6207 4.58608 18.9953 5.03412 18.9953H25.1887C25.6368 18.9953 26 18.6207 26 18.1586V0.836705C26.0001 0.37454 25.6368 0 25.1888 0ZM2.76183 7.32891H6.24029C6.68834 7.32891 7.05157 6.95429 7.05157 6.4922C7.05157 6.03011 6.68834 5.6555 6.24029 5.6555H2.76183C2.31378 5.6555 1.95055 6.03011 1.95055 6.4922C1.95055 6.95429 2.31378 7.32891 2.76183 7.32891ZM6.24028 10.3344H0.811279C0.363232 10.3344 0 9.95977 0 9.49769C0 9.0356 0.363232 8.66098 0.811279 8.66098H6.24028C6.68833 8.66098 7.05156 9.0356 7.05156 9.49769C7.05156 9.95977 6.68833 10.3344 6.24028 10.3344ZM9.41225 13.1879C9.26098 13.1879 9.10809 13.1444 8.97172 13.0532C8.59573 12.8019 8.4885 12.2838 8.73232 11.8961L10.2396 9.49776L8.73232 7.09931C8.48864 6.71154 8.59588 6.19346 8.97187 5.94215C9.34771 5.69076 9.85019 5.80143 10.0939 6.1892L11.6473 8.66113H18.5758L20.1291 6.18928C20.3728 5.80143 20.8751 5.69083 21.2511 5.94215C21.6272 6.19346 21.7344 6.71154 21.4907 7.09931L19.9835 9.49776L21.4907 11.8961C21.7344 12.2838 21.6272 12.802 21.2512 13.0533C20.8751 13.3045 20.3728 13.1939 20.1291 12.8062L18.5758 10.3344H11.6472L10.0938 12.8062C9.93847 13.0533 9.67805 13.1879 9.41225 13.1879ZM6.24029 11.6664C6.68834 11.6664 7.05157 12.041 7.05157 12.5031C7.05157 12.9652 6.68834 13.3398 6.24029 13.3398H2.76183C2.31378 13.3398 1.95055 12.9652 1.95055 12.5031C1.95055 12.041 2.31378 11.6664 2.76183 11.6664H6.24029Z" fill="#342DAB" /> </svg>
                <span id="button-text-span-inattachment" class="button-text-span-ulazna" style="width: 58.56px">{{ dodaj_ulazna_text }}</span>
                <div id="svg-spin-inattachment" class="svg-spin-wrapper-ulazna" style="display: none; width: 58.56px; justify-content: center">
                  <svg class="update-event-spin spinner-ulazna" id="add-to-ulazna" style="display: none" viewBox="0 0 50 50"> <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle> </svg>
                </div>
              </div>
              <div v-if="isFilePdf()" :class="[ 'button-dodijeli-komunikaciji', adding_to_izlazna ? 'active' : '', ]" @click="!adding_to_izlazna ? outAttachmentToPDF() : ''">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1888 0H5.03412C4.58608 0 4.22284 0.374616 4.22284 0.836705V3.10904C4.22284 3.57113 4.58608 3.94575 5.03412 3.94575C5.48217 3.94575 5.8454 3.57113 5.8454 3.10904V1.67341H24.3774V17.3219H5.8454V15.8863C5.8454 15.4242 5.48217 15.0496 5.03412 15.0496C4.58608 15.0496 4.22284 15.4242 4.22284 15.8863V18.1586C4.22284 18.6207 4.58608 18.9953 5.03412 18.9953H25.1887C25.6368 18.9953 26 18.6207 26 18.1586V0.836705C26.0001 0.37454 25.6368 0 25.1888 0ZM2.76183 7.32891H6.24029C6.68834 7.32891 7.05157 6.95429 7.05157 6.4922C7.05157 6.03011 6.68834 5.6555 6.24029 5.6555H2.76183C2.31378 5.6555 1.95055 6.03011 1.95055 6.4922C1.95055 6.95429 2.31378 7.32891 2.76183 7.32891ZM6.24028 10.3344H0.811279C0.363232 10.3344 0 9.95977 0 9.49769C0 9.0356 0.363232 8.66098 0.811279 8.66098H6.24028C6.68833 8.66098 7.05156 9.0356 7.05156 9.49769C7.05156 9.95977 6.68833 10.3344 6.24028 10.3344ZM9.41225 13.1879C9.26098 13.1879 9.10809 13.1444 8.97172 13.0532C8.59573 12.8019 8.4885 12.2838 8.73232 11.8961L10.2396 9.49776L8.73232 7.09931C8.48864 6.71154 8.59588 6.19346 8.97187 5.94215C9.34771 5.69076 9.85019 5.80143 10.0939 6.1892L11.6473 8.66113H18.5758L20.1291 6.18928C20.3728 5.80143 20.8751 5.69083 21.2511 5.94215C21.6272 6.19346 21.7344 6.71154 21.4907 7.09931L19.9835 9.49776L21.4907 11.8961C21.7344 12.2838 21.6272 12.802 21.2512 13.0533C20.8751 13.3045 20.3728 13.1939 20.1291 12.8062L18.5758 10.3344H11.6472L10.0938 12.8062C9.93847 13.0533 9.67805 13.1879 9.41225 13.1879ZM6.24029 11.6664C6.68834 11.6664 7.05157 12.041 7.05157 12.5031C7.05157 12.9652 6.68834 13.3398 6.24029 13.3398H2.76183C2.31378 13.3398 1.95055 12.9652 1.95055 12.5031C1.95055 12.041 2.31378 11.6664 2.76183 11.6664H6.24029Z" fill="#342DAB" /> </svg>
                <span id="button-text-span-outattachment" class="button-text-span-izlazna" style="width: 60.26px">{{ dodaj_izlazna_text }}</span>
                <div id="svg-spin-outattachment" class="svg-spin-wrapper-izlazna" style="display: none; width: 60.26px; justify-content: center">
                  <svg class="update-event-spin spinner-izlazna" id="add-to-izlazna" style="display: none" viewBox="0 0 50 50"> <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle> </svg>
                </div>
              </div>
              <div  :class="[ 'button-dodijeli-komunikaciji', adding_to_radni ? 'active' : '', ]" @click="!adding_to_radni ? radniAttachment() : ''">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1888 0H5.03412C4.58608 0 4.22284 0.374616 4.22284 0.836705V3.10904C4.22284 3.57113 4.58608 3.94575 5.03412 3.94575C5.48217 3.94575 5.8454 3.57113 5.8454 3.10904V1.67341H24.3774V17.3219H5.8454V15.8863C5.8454 15.4242 5.48217 15.0496 5.03412 15.0496C4.58608 15.0496 4.22284 15.4242 4.22284 15.8863V18.1586C4.22284 18.6207 4.58608 18.9953 5.03412 18.9953H25.1887C25.6368 18.9953 26 18.6207 26 18.1586V0.836705C26.0001 0.37454 25.6368 0 25.1888 0ZM2.76183 7.32891H6.24029C6.68834 7.32891 7.05157 6.95429 7.05157 6.4922C7.05157 6.03011 6.68834 5.6555 6.24029 5.6555H2.76183C2.31378 5.6555 1.95055 6.03011 1.95055 6.4922C1.95055 6.95429 2.31378 7.32891 2.76183 7.32891ZM6.24028 10.3344H0.811279C0.363232 10.3344 0 9.95977 0 9.49769C0 9.0356 0.363232 8.66098 0.811279 8.66098H6.24028C6.68833 8.66098 7.05156 9.0356 7.05156 9.49769C7.05156 9.95977 6.68833 10.3344 6.24028 10.3344ZM9.41225 13.1879C9.26098 13.1879 9.10809 13.1444 8.97172 13.0532C8.59573 12.8019 8.4885 12.2838 8.73232 11.8961L10.2396 9.49776L8.73232 7.09931C8.48864 6.71154 8.59588 6.19346 8.97187 5.94215C9.34771 5.69076 9.85019 5.80143 10.0939 6.1892L11.6473 8.66113H18.5758L20.1291 6.18928C20.3728 5.80143 20.8751 5.69083 21.2511 5.94215C21.6272 6.19346 21.7344 6.71154 21.4907 7.09931L19.9835 9.49776L21.4907 11.8961C21.7344 12.2838 21.6272 12.802 21.2512 13.0533C20.8751 13.3045 20.3728 13.1939 20.1291 12.8062L18.5758 10.3344H11.6472L10.0938 12.8062C9.93847 13.0533 9.67805 13.1879 9.41225 13.1879ZM6.24029 11.6664C6.68834 11.6664 7.05157 12.041 7.05157 12.5031C7.05157 12.9652 6.68834 13.3398 6.24029 13.3398H2.76183C2.31378 13.3398 1.95055 12.9652 1.95055 12.5031C1.95055 12.041 2.31378 11.6664 2.76183 11.6664H6.24029Z" fill="#342DAB" /> </svg>
                <span id="button-text-span-radni" class="button-text-span-ulazna" style="width: 58.56px">{{ dodaj_radna_text }}</span>
                <div id="svg-spin-radni" class="svg-spin-wrapper-ulazna" style="display: none; width: 58.56px; justify-content: center">
                  <svg class="update-event-spin spinner-ulazna" id="add-to-radni" style="display: none" viewBox="0 0 50 50"> <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle> </svg>
                </div>
              </div>
              <div  :class="[ 'button-dodijeli-komunikaciji', adding_to_popratna ? 'active' : '', ]" @click="!adding_to_popratna ? popratniAttachment() : ''">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1888 0H5.03412C4.58608 0 4.22284 0.374616 4.22284 0.836705V3.10904C4.22284 3.57113 4.58608 3.94575 5.03412 3.94575C5.48217 3.94575 5.8454 3.57113 5.8454 3.10904V1.67341H24.3774V17.3219H5.8454V15.8863C5.8454 15.4242 5.48217 15.0496 5.03412 15.0496C4.58608 15.0496 4.22284 15.4242 4.22284 15.8863V18.1586C4.22284 18.6207 4.58608 18.9953 5.03412 18.9953H25.1887C25.6368 18.9953 26 18.6207 26 18.1586V0.836705C26.0001 0.37454 25.6368 0 25.1888 0ZM2.76183 7.32891H6.24029C6.68834 7.32891 7.05157 6.95429 7.05157 6.4922C7.05157 6.03011 6.68834 5.6555 6.24029 5.6555H2.76183C2.31378 5.6555 1.95055 6.03011 1.95055 6.4922C1.95055 6.95429 2.31378 7.32891 2.76183 7.32891ZM6.24028 10.3344H0.811279C0.363232 10.3344 0 9.95977 0 9.49769C0 9.0356 0.363232 8.66098 0.811279 8.66098H6.24028C6.68833 8.66098 7.05156 9.0356 7.05156 9.49769C7.05156 9.95977 6.68833 10.3344 6.24028 10.3344ZM9.41225 13.1879C9.26098 13.1879 9.10809 13.1444 8.97172 13.0532C8.59573 12.8019 8.4885 12.2838 8.73232 11.8961L10.2396 9.49776L8.73232 7.09931C8.48864 6.71154 8.59588 6.19346 8.97187 5.94215C9.34771 5.69076 9.85019 5.80143 10.0939 6.1892L11.6473 8.66113H18.5758L20.1291 6.18928C20.3728 5.80143 20.8751 5.69083 21.2511 5.94215C21.6272 6.19346 21.7344 6.71154 21.4907 7.09931L19.9835 9.49776L21.4907 11.8961C21.7344 12.2838 21.6272 12.802 21.2512 13.0533C20.8751 13.3045 20.3728 13.1939 20.1291 12.8062L18.5758 10.3344H11.6472L10.0938 12.8062C9.93847 13.0533 9.67805 13.1879 9.41225 13.1879ZM6.24029 11.6664C6.68834 11.6664 7.05157 12.041 7.05157 12.5031C7.05157 12.9652 6.68834 13.3398 6.24029 13.3398H2.76183C2.31378 13.3398 1.95055 12.9652 1.95055 12.5031C1.95055 12.041 2.31378 11.6664 2.76183 11.6664H6.24029Z" fill="#342DAB" /> </svg>
                <span id="button-text-span-popratna" class="button-text-span-ulazna" style="width: 71.56px">{{ dodaj_popratna_text }}</span>
                <div id="svg-spin-popratna" class="svg-spin-wrapper-ulazna" style="display: none; width: 71.56px; justify-content: center">
                  <svg class="update-event-spin spinner-ulazna" id="add-to-popratna" style="display: none" viewBox="0 0 50 50"> <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle> </svg>
                </div>
              </div>
              <div :class="['button-dodijeli-komunikaciji']" @click="getAttachment()">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.5 0V9.375H3.5L14 18.75L24.5 9.375H17.5V0H10.5ZM0 21.875V25H28V21.875H0Z" fill="#342DAB" /> </svg>
                <span id="button-text-span-getAttachment" class="button-text-span-izlazna" style="width: 60.26px">{{ $t("components.pregled_poste.btn_4") }}</span>
              </div>
            </div>
          </div>
          <v-row class="email-client-row">
            <v-col md="4" style="border-right: 2px solid rgba(230, 230, 230, 0.52)" class="email-list-wrapper">
              <div class="email-left-navigation">
                <div class="email-folder-wrapp" v-if="selected_type == 0">
                  <div :class="[fold_type == 0 ? 'active' : '', 'troskovnici-button']" @click="fold_type = 0">
                    <div>{{$t("components.pregled_poste.received")}}
                      <svg class="mail-svg" width="14" height="13" viewBox="0 0 14 13" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M12.8201 2.58296C13.3177 2.93687 13.669 3.47962 13.7652 4.11049C13.799 4.33156 13.8293 4.55301 13.8563 4.77476C14.0652 6.68747 14.0559 8.89331 13.7652 10.7983C13.6044 11.8523 12.7316 12.6604 11.6543 12.7527L10.5283 12.8491C8.18053 13.0503 5.81947 13.0503 3.47169 12.8491L2.34573 12.7527C1.26836 12.6604 0.395565 11.8523 0.234751 10.7983C-0.0558821 8.89332 -0.0651922 6.68734 0.143669 4.77464C0.170667 4.55293 0.201028 4.33152 0.234751 4.11049C0.330869 3.48049 0.681333 2.93837 1.1778 2.58443L1.17723 2.57948L1.21247 2.56019C1.34108 2.47195 1.47907 2.39617 1.62462 2.3345L4.91694 0.531725C6.21168 -0.177241 7.78602 -0.177242 9.08076 0.531724L12.3655 2.33034C12.518 2.39414 12.6623 2.47343 12.7964 2.56628L12.8205 2.57951L12.8201 2.58296ZM12.1932 3.49692L8.53766 1.49527C7.58067 0.971251 6.41703 0.971251 5.46004 1.49527L1.81306 3.49226C1.56443 3.67715 1.38953 3.95401 1.34064 4.2744C1.33193 4.33155 1.32344 4.38872 1.3152 4.44592L5.46116 6.71613C6.41815 7.24015 7.58179 7.24015 8.53877 6.71613L12.6848 4.44589C12.6765 4.3887 12.6681 4.33154 12.6593 4.2744C12.6109 3.95669 12.4385 3.68179 12.1932 3.49692ZM12.7448 10.012C12.9226 8.55777 12.9482 7.09003 12.8216 5.6319L9.08188 7.67968C7.78714 8.38864 6.2128 8.38865 4.91805 7.67969L1.17835 5.63193C1.05181 7.09005 1.07742 8.55778 1.25516 10.012C1.28055 10.2198 1.30904 10.4272 1.34064 10.6344C1.35853 10.7516 1.39331 10.863 1.4424 10.9663C1.62364 11.3474 2.00005 11.6166 2.44258 11.6545L3.56854 11.751C5.85187 11.9467 8.14812 11.9467 10.4315 11.751L11.5574 11.6546C11.9089 11.6244 12.2187 11.4484 12.4221 11.1862C12.5441 11.029 12.6279 10.8407 12.6593 10.6343C12.6909 10.4272 12.7194 10.2197 12.7448 10.012Z"
                          fill="#2A306B" />
                      </svg>
                    </div>
                  </div>
                  <div :class="[fold_type == 1 ? 'active' : '', 'izdani-racuni-button']" @click="fold_type = 1">
                    <div>{{$t("components.pregled_poste.sent")}}
                      <svg class="mail-svg" width="14" height="11" viewBox="0 0 14 11" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M0.143669 2.84232C-0.0651922 4.73928 -0.0558821 6.92711 0.234751 8.81637C0.395565 9.86174 1.26836 10.6631 2.34573 10.7547L3.47169 10.8504C5.81947 11.0499 8.18053 11.0499 10.5283 10.8504L11.6543 10.7547C12.7316 10.6631 13.6044 9.86174 13.7652 8.81637C14.0559 6.9271 14.0652 4.73941 13.8563 2.84243C13.8293 2.62251 13.799 2.40289 13.7652 2.18363C13.6044 1.13826 12.7316 0.33685 11.6543 0.245302L10.5283 0.149625C8.18052 -0.049875 5.81947 -0.0498748 3.47169 0.149625L2.34573 0.245302C1.26836 0.33685 0.395565 1.13826 0.234751 2.18363C0.201028 2.40285 0.170667 2.62244 0.143669 2.84232ZM3.56854 1.2387C5.85187 1.04468 8.14812 1.04468 10.4315 1.2387L11.5574 1.33438C12.1198 1.38217 12.5754 1.80051 12.6593 2.34619C12.6681 2.40286 12.6765 2.45956 12.6848 2.51628L8.53877 4.76784C7.58179 5.28754 6.41815 5.28754 5.46116 4.76784L1.3152 2.5163C1.32344 2.45957 1.33193 2.40287 1.34064 2.34619C1.42459 1.80051 1.88019 1.38217 2.44258 1.33438L3.56854 1.2387ZM12.8216 3.69252C12.9663 5.34524 12.9122 7.01041 12.6593 8.65381C12.5754 9.19949 12.1198 9.61783 11.5574 9.66562L10.4315 9.7613C8.14812 9.95532 5.85187 9.95532 3.56854 9.7613L2.44258 9.66562C1.88019 9.61783 1.42459 9.19949 1.34064 8.65381C1.08784 7.01042 1.03374 5.34525 1.17835 3.69255L4.91805 5.72345C6.2128 6.42658 7.78714 6.42659 9.08188 5.72345L12.8216 3.69252Z"
                          fill="#2A306B" />
                      </svg>
                    </div>
                  </div>
                </div><!-- end email folder wrap -->

                <v-menu v-if="selected_type == 0 || selected_type == 3" ref="menu1" v-model="menu1"
                  :close-on-content-click="false" transition="scale-transition" offset-y max-width="480px"
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dateRangeText" readonly clearable :label="$t('components.pregled_poste.period')" v-bind="attrs"
                      @click="menu1 = !menu1" v-on="on" class="email-date-picker"></v-text-field>
                  </template>
                  <v-date-picker locale="hr" :first-day-of-week="1" v-model="date_range" range no-title :pickerDate.sync="pickerDate">
                  </v-date-picker>
                </v-menu><!-- end odaberite period -->
              </div><!-- end email left navigation -->

              <div class="mail-srch" v-if="selected_type == 2">
                <v-text-field class="naplata-filter" type="text" :label="$t('components.pregled_poste.search_label')" v-model="srch_txt" clearable
                  @keyup.enter="searchByText()"></v-text-field>
                <div class="top-search-button" @click="searchByText()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 26 26">
                    <g>
                      <g>
                        <path fill="#fff"
                          d="M25.714 25.714a.952.952 0 0 1-1.346 0l-6.295-6.295A10.95 10.95 0 0 1 11 21.999C4.925 22 0 17.076 0 11 0 4.926 4.925 0 11 0s11 4.926 11 11c0 2.696-.972 5.161-2.581 7.074l6.295 6.295a.952.952 0 0 1 0 1.346zM20 11a9 9 0 1 0-18 0 9 9 0 0 0 18 0z" />
                      </g>
                    </g>
                  </svg>
                </div>
              </div>

              <div class="email-list">
                <div class="single-prev-mail" v-for="(singleMail, key) in emails" :key="key"
                  @click="getSingleMail(singleMail.id)">
                  <div class="single-mail" @click="current = key" :class="{ current: key == current }">
                    <div class="mail-sender-email">
                      <div class="mail-row">
                        <span class="comm-label"> {{ $t("components.pregled_poste.header.t1") }}:</span>
                        {{ singleMail.sender.emailAddress.name }}
                        <div class="attachment-icon" v-if="singleMail.hasAttachments">
                          <svg width="20" height="20" viewBox="0 0 35 41" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M25.043 0C22.4848 0 19.9265 1.05339 17.9703 2.95951L4.02544 16.6034C-1.34181 21.9706 -1.34181 30.6485 4.02544 36.0659C9.39269 41.4332 18.0706 41.4332 23.488 36.0659L29.7582 29.7958L26.297 26.3346L20.4783 32.0029L20.0269 32.655C16.5657 36.1161 10.9477 36.1161 7.48656 32.655C4.0756 29.244 4.17592 23.7263 7.48656 20.2651L21.4314 6.4708C23.3877 4.51451 26.6482 4.51451 28.6546 6.4708C30.6109 8.42709 30.5106 11.5371 28.6546 13.5435L16.1143 25.9334C15.6127 26.435 14.7599 26.435 14.2082 25.9334C13.7066 25.4317 13.7066 24.579 14.2082 24.0272L14.5091 23.8767L19.0738 19.1616L15.6127 15.7005L10.747 20.5661C8.33931 22.9738 8.33931 26.9366 10.747 29.3443C13.1548 31.7521 17.1175 31.8022 19.5253 29.3443L32.0656 17.105C35.9781 13.1924 35.9781 6.87209 32.0656 3.00967C30.1093 1.05339 27.6012 0.0501612 24.9928 0.0501612L25.043 0Z"
                              fill="#B8B8C1" />
                          </svg>
                        </div>


                      </div>
                      <div class="mail-row">
                        <span class="comm-label"> {{ $t("components.pregled_poste.fold_1") }}:</span>
                        <!-- {{singleMail['@odata.type'] != undefined && singleMail['@odata.type'].includes('#microsoft.graph.eventMessage') ? 'Event Message' : singleMail.sender.emailAddress.address.includes('O=EXCHANGELABS') ? 'Ja' : singleMail.sender.emailAddress.address }} -->
                        {{ singleMail.sender.emailAddress.address }}
                      </div>
                    </div>
                    <div class="mail-row mail-row-subject">
                      <span class="comm-label"> {{ $t("components.pregled_poste.header.t3") }}:</span>
                      {{ singleMail.subject }}
                    </div>
                  </div>
                  <v-divider></v-divider>
                </div>
                <div v-if="fetching_mails" class="center-spinner">
                  <svg class="dot-spin" viewBox="0 0 50 50">
                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                  </svg>
                </div>
                <div v-if="emails.length == 0 && !fetching_mails" class="single-mail" @click="current = key">
                  <div class="mail-sender-email">
                    <div class="mail-row">
                      <span class="comm-label"></span>
                    </div>
                    <div class="mail-row">
                      <span class="comm-label"></span>
                      <!-- {{singleMail['@odata.type'] != undefined && singleMail['@odata.type'].includes('#microsoft.graph.eventMessage') ? 'Event Message' : singleMail.sender.emailAddress.address.includes('O=EXCHANGELABS') ? 'Ja' : singleMail.sender.emailAddress.address }} -->
                    </div>
                  </div>
                  <div class="mail-row mail-row-subject">
                    <span class="comm-label"> {{ $t("components.pregled_poste.empty_title") }}</span>
                    {{ $t("components.pregled_poste.empty_title") }}
                  </div>
                </div>
                <div @click="getEmails" class="see-more" v-if="response_size_enough && emails.length > 0">
                  <div class="see-more-wrapper">
                    <span>{{ $t("components.pregled_poste.show_more") }}</span>
                  </div>
                </div>
              </div>

            </v-col>
            <v-col md="8">
              <div class="single-mail active-content" v-if="selected_email != null && dialog" style="height: 1000">
                <div class="mail-content">
                  <div> <b>{{ $t("components.pregled_poste.header.t1") }}: </b>{{
                    selected_email.sender.emailAddress.name
                  }}
                    &#60;{{ selected_email.sender.emailAddress.address }}&#62;</div>
                  <div> <b>{{ $t("components.pregled_poste.header.t2") }}: </b><span
                      v-for="(to_ppl, key) in selected_email.toRecipients" :key="key">{{ to_ppl.emailAddress.name }}
                      &#60;{{ to_ppl.emailAddress.address }}&#62; </span></div>
                  <div v-if="selected_email.ccRecipients.length > 0"> <b>CC: </b> <span
                      v-for="(cc_ppl, key) in selected_email.ccRecipients" :key="key">{{ cc_ppl.emailAddress.name }}
                      &#60;{{ cc_ppl.emailAddress.address }}&#62; </span></div>
                  <div v-if="selected_email.bccRecipients.length > 0"> <b>BCC: </b> <span
                      v-for="(bcc_ppl, key) in selected_email.bccRecipients" :key="key">{{ bcc_ppl.emailAddress.name }}
                      &#60;{{ bcc_ppl.emailAddress.address }}&#62; </span></div>
                  <div> <b>{{ $t("components.pregled_poste.header.t3") }}: </b>{{ selected_email.subject }}</div>
                  <div> <b>{{ $t("components.pregled_poste.header.t4") }}: </b>{{
                    getRegDateTime(selected_email.createdDateTime)
                  }}</div>
                  <div v-if="listed_attachments.length > 0"> <b>{{ $t("components.pregled_poste.header.t5") }}: </b>{{
                    attachmentList(listed_attachments)
                  }}
                  </div>

                  <!-- <div> <b>Kreirano: </b>{{subject.subject}}</div> -->
                </div>
                <!-- <iframe v-if="selected_email.body.content != ''" class="mail-content" :srcdoc="selected_email.body.content"></iframe> -->
                <div v-if="selected_email.body.content != ''" class="mail-content" v-html="selected_email.body.content"
                  @click="selected_attachment = null">
                </div>
                <div v-else>{{ $t("components.pregled_poste.empty_mail") }}</div>
                <div class=" mail-att-wrapp opening-radni-dokumenti">
                  <div class="inside-radni-dokumenti">
                    <div :class="listed_attachments.length > 3 ? 'row-multiple' : 'row'" :sort="false"
                      v-if="selected_email.hasAttachments">
                      <div v-for="(upFile, key) in listed_attachments" :key="key" class="attachment-hover-wrapp active"
                        @click="selected_attachment = upFile">
                        <div :class="[
                          listed_attachments.length > 3
                            ? 'radni-dokument-inside-multiple'
                            : 'radni-dokument-inside',
                          'preneseni-dokument', isActiveFile(upFile) ? 'active' : ''
                        ]">
                          <div :class="[
                            listed_attachments.length > 3
                              ? 'document-image-wrapper-multiple'
                              : 'document-image-wrapper',
                          ]">
                            <img class="preneseni-dokument-image" :src="returnFileType(upFile.name)" />
                          </div>
                          <div class="preneseni-dokument-title">
                            {{ upFile.name }}
                          </div>
                          <!-- <div
                          v-show="listed_attachments.length > 3"
                          class="remove-document-multiple"
                          v-if="is_permission_inside('delete')"
                          @click="deleteFileInSpis(upFile)"
                        >
                          <span>X</span>
                        </div> -->
                        </div>
                        <!-- <div class="attachment-act-wrapp" >
                          <div class="single-act" >
                            <div class="inside-text">Preuzmi</div>
                            <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" @click=getAttachment(key)>
                              <path d="M10.5 0V9.375H3.5L14 18.75L24.5 9.375H17.5V0H10.5ZM0 21.875V25H28V21.875H0Z"
                                fill="#B8B8C1" />
                            </svg>
                          </div>
                          <div class="single-act"  v-if="isFilePdf(upFile.name)" @click="selected_attachment = upFile">
                            <svg viewBox="0 0 25 25" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path d="M0.5 14H9.875V21L19.25 10.5L9.875 0L9.875 7H0.5L0.5 14Z" fill="#B8B8C1" />
                            </svg>

                          </div>

                        </div> -->
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div v-if="fetching" class="center-spinner">
                <svg style="left:68%;" class="dot-spin" viewBox="0 0 50 50">
                  <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                </svg>
              </div>
            </v-col>
            <v-divider vertical></v-divider>
          </v-row>
          <!-- <v-divider>

          </v-divider>
          <v-card-actions class="email-client-bottom">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Uploadaj
          </v-btn> -->
          <!-- </v-card-actions> -->
        </v-card>
        <v-snackbar v-model="snackbar" :timeout="snackTimeout" color="snack-custom-dark-blue" elevation="24">
          {{ $t("snackbars.no_mail") }}
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
              {{$t("repetitive.okay")}}
            </v-btn>
          </template>
        </v-snackbar>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import ms_email from "@/apiCallers/promise_handler_db/ms_email";
import { getCaseData } from "@/router/case/handler"

import gsap from "gsap";
import $ from "jquery";
import moment from "moment";
import graph from "@/services/graph.js";

import {FILE_TYPE_TO_PDF} from "@/config/general_vars";
import { switchGlobalLoaderMessage, switchGlobalLoaderState } from '../../helpers/loader/global';
import { fileDirectUpload, fileDownloadFinalization, fileFinalization } from '../../helpers/file/conversion';
export default {
  name: "pregled-poste",
  props: {
    accessToken: {
      type: String,
      required: true,
      default: null,
    },
    ulaz: {
      type: String,
      required: true,
      default: null,
    },
    izlaz: {
      type: String,
      required: true,
      default: null,
    },
    radni_id: {
      type: String,
      required: true,
      default: null,
    },
    popratni_id: {
      type: String,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      select_page_limit: 0,
      menu1: false,
      srch_txt: "",
      final_srch_text: "",
      // Folder type 0-inbox,1-sent
      fold_type: 0,
      fold_names: ["inbox", "sentitems"],
      date_range: [],
      pickerDate: null,
      page_limits: [
        { name: this.$t("components.pregled_poste.all"), value: 0 },
        { name: "1", value: 1 },
        { name: "2", value: 2 },
        { name: "3", value: 3 },
        { name: "4", value: 4 },
      ],


      skip: 0,
      dialog: false,
      emails: [],
      spisi: [],
      selected_email: null,
      email_id: null,
      current: -1,
      dropSpisOpen: false,
      adding_to_ulazna: false,
      adding_to_izlazna: false,
      adding_to_radni: false,
      adding_to_popratna: false,
      dodaj_spis_text: this.$t("components.pregled_poste.btn_1"),
      dodaj_ulazna_text: this.$t("components.pregled_poste.btn_2"),
      dodaj_radna_text: this.$t("components.pregled_poste.btn_5"),
      dodaj_popratna_text: this.$t("components.pregled_poste.btn_6"),
      dodaj_izlazna_text: this.$t("components.pregled_poste.btn_3"),
      chosen_spis: "",
      fetching: false,
      fetching_mails: false,
      selected_type: 0,
      snackbar: false,
      snackTimeout: 5000,
      listed_attachments: [],

      response_size_enough: true,

      selected_attachment: null,
      next_link: null,
    };
  },
  computed: {
    dateRangeText: {
      get() {
        var ret_date_string = [];
        this.date_range.forEach((p) => {
          ret_date_string.push(moment(p).format("l"));
        });
        return ret_date_string.join(" ~ ");
      },
      set(new_val) {
        // console.log(new_val)
        if (new_val == null) {
          this.date_range = [];
        }
      }
    },
  },
  methods: {
    async uploadSingleSpisFile(counter, final_num) {
      switchGlobalLoaderState(this.$t("components.file_management.sharepointUpload.uploading"))

                let uploaded = false;
                await fileDownloadFinalization(
                this.multi_file_list,
                this.$route.params.uid,
                this.selected_spis_dir
                )
                .then((resp) => {
                    if(resp.failed.length > 0){
                    alert(this.$t("components.file_management.sharepointUpload.error", { files: resp.failed.join(", ") }));
                    } else {
                    uploaded = true;
                    }
                })
                .catch((err) => {
                    console.error("Error moving files to spis:", err);
                    alert(this.$t("components.file_management.sharepointUpload.error", { files: this.multi_file_list.map(f => f.name).join(", ") }));
                })
                .finally(() => {
                    this.move_spis = false;
                    // Only report success when every file actually landed.
                    if (uploaded) {
                    switchGlobalLoaderMessage(this.$t("components.file_management.sharepointUpload.success"));
                    }

                    setTimeout(() => {
                    this.multi_file_list = [];
                    switchGlobalLoaderState()
                    }, uploaded ? 2000 : 0);

                });
      // this.accessToken = this.$store.state.aToken;
      // let group_url = this.$route.params.uid;
      
      // var tmp_file = this.multi_file_list[counter];
      // let file_name_arr = tmp_file.name.split(".");
      // let file_ext = file_name_arr[file_name_arr.length - 1];

      // file_name_arr.pop();
      // let final_name = file_name_arr.join("");

      // let putanja = "";

      // let new_path = "";

      // if (
      //   file_ext == "jpg" ||
      //   file_ext == "jpeg" ||
      //   file_ext == "png" ||
      //   file_ext == "pdf"
      // ) {
      //   //logic for non pdf
      //   new_path = tmp_file["@microsoft.graph.downloadUrl"];
      // } else {
      //   putanja = tmp_file.parentReference.path.replace("/drive", "");

      //   new_path =
      //     "/drives/" +
      //     tmp_file.parentReference.driveId +
      //     putanja +
      //     "/" +
      //     encodeURIComponent(tmp_file.name);
      // }
      // let existing_number;
      // await graph
      //   .checkFolderContainsFile(
      //     this.group_url,
      //     this.selected_spis_dir.id,
      //     final_name
      //   )
      //   .then((resp) => {
      //     existing_number = resp.value.length;
      //   });
      // if (existing_number > 0) {
      //   final_name = final_name + " (" + existing_number + ")";
      // }
      // await share
      //   .convertToPDF(
      //     this.accessToken,
      //     this.group_url,
      //     this.selected_spis_dir.id,
      //     new_path,
      //     final_name,
      //     file_ext,
      //     this.$store.state.logged_in_user.uid,
      //     this.selected_spis_dir.name
      //   )
        
      //   .catch(() => {
      //     //this.uploadSingleSpisFile(counter,final_num);
      //     console.log("Neuspjelo dohvaćan je datoteke ", final_name);
        // });
    },
    searchByText: function () {
      if (this.srch_txt == null) {
        this.srch_txt = "";
      }
      this.skip = 0;
      this.final_srch_text = this.srch_txt
      this.next_link = null;
      this.emails = [];
      this.selected_email = null;
      this.email_id = null;
      this.current = -1;
      this.getEmails();
    },
    attachmentList(att_list) {
      att_list = att_list.map((p) => p.name)
      return att_list.join(", ")
    },
    getRegDateTime(dt) {
      return moment(dt).format("LLLL")
    },
    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext].toLowerCase();

      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotm":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pptx":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "ppt":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xlsx":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "jpg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "jpeg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "png":
          return_val = require("@/assets/img/png_icon.svg");
          break;
        case "folder":
          return_val = require("@/assets/img/folder_yellow.svg");
          break;
        default:
          return_val = require("@/assets/img/dat_icon.svg");
          break;
      }
      return return_val;
    },
    isActiveFile(upFile) {
      if (this.selected_attachment == null)
        return false;
      else return this.selected_attachment.id == upFile.id;
    },
    isFilePdf() {
      var idx_ext = this.selected_attachment.name.split(".").length - 1;
      var extension = this.selected_attachment.name.split(".")[idx_ext].toLowerCase();
      return FILE_TYPE_TO_PDF.includes(extension);
    },
    async getAttachment() {
      let tmp_att = this.selected_attachment
      //pripremanje download linka
      console.log(tmp_att);
      var raw = window.atob(tmp_att.contentBytes);
      var rawLength = raw.length;
      var array = new Uint8Array(new ArrayBuffer(rawLength));      // pass your byte response to this constructor

      for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      var newBlob = new Blob([array], {
        type: tmp_att.contentType,
      });
      var data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = tmp_att.name;
      link.click();
    },
    chooseSpis(id) {
      if (this.chosen_spis != id) {
        this.chosen_spis = id;
      } else {
        this.chosen_spis = "";
      }
    },
    openDrop() {
      gsap.to(".custom-dropdown-elements-wrapper", 0, { display: "block" });
      gsap.fromTo(
        ".custom-dropdown-elements-wrapper",
        0.5,
        { y: -10 },
        { y: 0, opacity: 1 }
      );
    },
    closeDrop() {
      let tl = gsap.timeline();
      tl.to(".custom-dropdown-elements-wrapper", 0.5, { y: -10, opacity: 0 });
      tl.to(".custom-dropdown-elements-wrapper", 0, { display: "none" });
    },
    openSpisDrop() {
      this.dropSpisOpen = !this.dropSpisOpen;
      if (this.dropSpisOpen) {
        this.openDrop();
      } else {
        this.closeDrop();
      }
    },
    async addToSpis() {
      this.snackbar = false;
      if (this.selected_email == null) {
        this.snackbar = true;
      } else if (!this.chosen_spis) {
        alert(this.$t("upload_popup.choose_folder"));
      } else {
        var tl = gsap.timeline();
        gsap.to("#svg-spin-spis", 0, { display: "flex" });
        gsap.to("#button-text-span-spis", 0, { display: "none", opacity: 0 });
        gsap.to("#add-to-spis", 0, { display: "block", opacity: 1 });
        this.closeDrop();
        let tmp_mail = this.selected_email;
        tmp_mail["attachment_text"] = ""
        if (this.listed_attachments.length > 0) {
          tmp_mail["attachment_text"] = this.$t('components.pregled_poste.part_of_doc') + this.attachmentList(this.listed_attachments);
        }

        //ANIMACIJA DODAVANJA
        //umjesto ovog timeouta zvati neku async funkciju za dodavanje
        //u spis i u .then() kopirati sve kaj je u timeoutu

        await ms_email
          .saveEmail(
            this.accessToken,
            this.email_id,
            this.$route.params.uid,
            this.chosen_spis,
            this.select_page_limit,
            tmp_mail
          ).then(() => {
            this.dodaj_spis_text = this.$t("components.pregled_poste.added_btn");
          })
          .catch(() => {
            this.dodaj_spis_text = this.$t("components.pregled_poste.err_btn");
          })
          .finally(() => {
            //resetiraj postavke i animiraj na pocetak
            gsap.to("#add-to-spis", 0, { display: "none", opacity: 0 });
            gsap.to("#svg-spin-spis", 0, { display: "none" });

            gsap.to("#button-text-span-spis", 0.3, {
              display: "block",
              opacity: 1,
            });
            setTimeout(() => {
              this.chosen_spis = "";
              this.select_page_limit = 0;
              this.dodaj_spis_text = this.$t("components.pregled_poste.btn_1");
              this.dropSpisOpen = false;
              this.$emit("refresh-view", true);
            }, 1200);
          })
      }
    },

    async addAttachmentToSpis() {

      this.handleAttachmentToPDF(this.$route.params.uid, this.chosen_spis);
      // this.snackbar = false;
      // if (this.selected_email == null) {
      //   this.snackbar = true;
      // } else {
      //   var tl = gsap.timeline();
      //   gsap.to("#svg-spin-spis", 0, { display: "flex" });
      //   gsap.to("#button-text-span-spis", 0, { display: "none", opacity: 0 });
      //   gsap.to("#add-to-spis", 0, { display: "block", opacity: 1 });
      //   this.closeDrop();

      //   await ms_email
      //     .saveEmailAttachment(
      //       this.accessToken,
      //       this.email_id,
      //       this.$route.params.uid,
      //       this.chosen_spis,
      //       this.selected_attachment,
      //       true
      //     ).then(() => {
      //       this.dodaj_spis_text = this.$t("components.pregled_poste.added_btn");
      //     })
      //     .catch(() => {
      //       this.dodaj_spis_text = this.$t("components.pregled_poste.err_btn");
      //     })
      //     .finally(() => {
      //       //resetiraj postavke i animiraj na pocetak
      //       gsap.to("#add-to-spis", 0, { display: "none", opacity: 0 });
      //       gsap.to("#svg-spin-spis", 0, { display: "none" });

      //       gsap.to("#button-text-span-spis", 0.3, {
      //         display: "block",
      //         opacity: 1,
      //       });
      //       setTimeout(() => {
      //         this.selected_attachment = null;
      //         this.chosen_spis = "";
      //         this.dodaj_spis_text = this.$t("components.pregled_poste.btn_1");
      //         this.dropSpisOpen = false;
      //         this.$emit("refresh-view", true);
      //       }, 1200);
      //     })
      // }
    },
    getEmails() {
      this.fetching_mails = true;
      let group_url = this.$route.params.uid;
      switch (this.selected_type) {
        case 0:
          let filter_date = "orderby=receivedDateTime desc";
          if (this.date_range.length == 1) {
            filter_date = "filter=receivedDateTime gt " + new Date(moment(this.date_range[0]).startOf("day").format()).toISOString() + " AND receivedDateTime lt " + new Date(moment(this.date_range[0]).endOf("day").format()).toISOString() + "&$orderby=receivedDateTime desc";
          } else if (this.date_range.length == 2) {
            filter_date = "filter=receivedDateTime gt " + new Date(moment(this.date_range[0]).startOf("day").format()).toISOString() + " AND receivedDateTime lt " + new Date(moment(this.date_range[1]).endOf("day").format()).toISOString() + "&$orderby=receivedDateTime desc";
          }
          graph.getInboxEmails(this.accessToken, this.next_link, filter_date, this.fold_names[this.fold_type]).then((response) => {
            this.next_link = response['@odata.nextLink']
            this.fetching_mails = false;
            this.emails = this.emails.concat(response.value.filter(e => e.sender != undefined));
            this.response_size_enough = response['@odata.nextLink'] != undefined && response['@odata.nextLink'] != null && response['@odata.nextLink'] != ''
          });
          break;
        case 1:
          ms_email.getAll(this.accessToken, this.skip, group_url).then((response) => {
            this.fetching_mails = false;
            this.emails = this.emails.concat(response.data);
            this.response_size_enough = response.data.length > 0;
            this.skip += 20
          });
          break;
        case 2:
          ms_email.getAllSrch(this.accessToken, this.skip, this.final_srch_text).then((response) => {
            this.fetching_mails = false;
            this.emails = this.emails.concat(response.data);
            this.response_size_enough = response.data.length > 0;
            this.skip += 20
          });
          break;
        case 3:
          let date_filter = "orderby=receivedDateTime desc";
          if (this.date_range.length == 1) {
            date_filter = "filter=receivedDateTime gt " + new Date(moment(this.date_range[0]).startOf("day").format()).toISOString() + " AND receivedDateTime lt " + new Date(moment(this.date_range[0]).endOf("day").format()).toISOString() + "&$orderby=receivedDateTime desc";
          } else if (this.date_range.length == 2) {
            date_filter = "filter=receivedDateTime gt " + new Date(moment(this.date_range[0]).startOf("day").format()).toISOString() + " AND receivedDateTime lt " + new Date(moment(this.date_range[1]).endOf("day").format()).toISOString() + "&$orderby=receivedDateTime desc";
          }
          graph.getMixedEmails(this.accessToken, this.next_link, date_filter).then((response) => {
            this.next_link = response['@odata.nextLink']
            this.fetching_mails = false;
            this.emails = this.emails.concat(response.value.filter(e => e.sender != undefined));
            this.response_size_enough = response['@odata.nextLink'] != undefined && response['@odata.nextLink'] != null && response['@odata.nextLink'] != ''
          });
          break;
      }

    },
    getSingleMail(idMail) {
      this.selected_attachment = null;
      this.listed_attachments = [];
      this.selected_email = null;
      this.fetching = true;
      this.email_id = idMail;
      ms_email.getById(this.accessToken, idMail).then((response) => {
        this.fetching = false
        this.selected_email = response.data.message;
        this.listed_attachments = response.data.final_attachments;
        this.selected_email["listed_attachments"] = response.data.final_attachments

      });
    },

    inMailToPDF() {
      this.snackbar = false;
      if (this.selected_email == null) {
        this.snackbar = true;
      } else {
        this.adding_to_ulazna = true;
        var tl = gsap.timeline();
        gsap.to("#svg-spin-ulazna", 0, { display: "flex" });
        gsap.to("#button-text-span-ulazna", 0, { display: "none", opacity: 0 });
        gsap.to("#add-to-ulazna", 0, { display: "block", opacity: 1 });
        //umjesto ovog timeouta postaviti zvati neku funkciju za dodavanje
        //u spis i u then kopirati sve kaj je u timeoutu
        let tmp_mail = this.selected_email;
        tmp_mail["attachment_text"] = ""
        if (this.listed_attachments.length > 0) {
          tmp_mail["attachment_text"] = this.$t('components.pregled_poste.part_of_doc') + this.attachmentList(this.listed_attachments);
        }
        ms_email
          .saveEmail(
            this.accessToken,
            this.email_id,
            this.$route.params.uid,
            this.ulaz,
            this.select_page_limit,
            tmp_mail
          )
          .then(() => {
            this.dodaj_ulazna_text = this.$t("components.pregled_poste.added_btn");
          })
          .catch((err) => {
            this.dodaj_ulazna_text = this.$t("components.pregled_poste.err_btn");
            console.log(err);
          })
          .finally(() => {
            gsap.to("#add-to-ulazna", 0, { display: "none", opacity: 0 });
            gsap.to("#svg-spin-ulazna", 0, { display: "none" });

            gsap.to("#button-text-span-ulazna", 0.3, {
              display: "block",
              opacity: 1,
            });
            setTimeout(() => {
              this.select_page_limit = 0;
              this.dodaj_ulazna_text = this.$t("components.pregled_poste.btn_2");
              this.adding_to_ulazna = false;
              this.$emit("refresh-view", true);
            }, 1200);
          });
      }
    },
    inAttachmentToPDF() {

      this.handleAttachmentToPDF(this.$route.params.uid, this.ulaz);

    },
    radniAttachment() {
      this.handleAttachmentDirect(this.$route.params.uid, this.radni_id);
      // this.snackbar = false;
      // if (this.selected_email == null) {
      //   this.snackbar = true;
      // } else {
      //   this.adding_to_radni = true;
      //   var tl = gsap.timeline();
      //   gsap.to("#svg-spin-radni", 0, { display: "flex" });
      //   gsap.to("#button-text-span-radni", 0, { display: "none", opacity: 0 });
      //   gsap.to("#add-to-radni", 0, { display: "block", opacity: 1 });
      //   //umjesto ovog timeouta postaviti zvati neku funkciju za dodavanje
      //   //u spis i u then kopirati sve kaj je u timeoutu
      //   ms_email
      //     .saveEmailAttachment(
      //       this.accessToken,
      //       this.email_id,
      //       this.$route.params.uid,
      //       this.radni_id,
      //       this.selected_attachment
      //     )
      //     .then(() => {
      //       this.dodaj_radna_text = this.$t("components.pregled_poste.added_btn");
      //     })
      //     .catch((err) => {
      //       this.dodaj_radna_text = this.$t("components.pregled_poste.err_btn")
      //       console.log(err);
      //     })
      //     .finally(() => {
      //       gsap.to("#add-to-radni", 0, { display: "none", opacity: 0 });
      //       gsap.to("#svg-spin-radni", 0, { display: "none" });


      //       gsap.to("#button-text-span-radni", 0.3, {
      //         display: "block",
      //         opacity: 1,
      //       });
      //       setTimeout(() => {
      //         this.selected_attachment = null;
      //         this.dodaj_radna_text = this.$t("components.pregled_poste.btn_5");
      //         this.adding_to_radni = false;
      //         this.$emit("refresh-view", true);
      //       }, 1200);
      //     });
      // }
    },
    popratniAttachment() {
      this.handleAttachmentDirect(this.$route.params.uid, this.popratni_id);
      // this.snackbar = false;
      // if (this.selected_email == null) {
      //   this.snackbar = true;
      // } else {
      //   this.adding_to_popratna = true;
      //   var tl = gsap.timeline();
      //   gsap.to("#svg-spin-popratna", 0, { display: "flex" });
      //   gsap.to("#button-text-span-popratna", 0, { display: "none", opacity: 0 });
      //   gsap.to("#add-to-popratna", 0, { display: "block", opacity: 1 });
      //   //umjesto ovog timeouta postaviti zvati neku funkciju za dodavanje
      //   //u spis i u then kopirati sve kaj je u timeoutu
      //   ms_email
      //     .saveEmailAttachment(
      //       this.accessToken,
      //       this.email_id,
      //       this.$route.params.uid,
      //       this.popratni_id,
      //       this.selected_attachment
      //     )
      //     .then(() => {
      //       this.dodaj_popratna_text = this.$t("components.pregled_poste.added_btn");
      //     })
      //     .catch((err) => {
      //       this.dodaj_popratna_text = this.$t("components.pregled_poste.err_btn")
      //       console.log(err);
      //     })
      //     .finally(() => {
      //       gsap.to("#add-to-popratna", 0, { display: "none", opacity: 0 });
      //       gsap.to("#svg-spin-popratna", 0, { display: "none" });

      //       gsap.to("#button-text-span-popratna", 0.3, {
      //         display: "block",
      //         opacity: 1,
      //       });
      //       setTimeout(() => {
      //         this.selected_attachment = null;
      //         this.dodaj_popratna_text = this.$t("components.pregled_poste.btn_5");
      //         this.adding_to_popratna = false;
      //         this.$emit("refresh-view", true);
      //       }, 1200);
      //     });
      // }
    },
    outMailToPDF() {
      this.snackbar = false;
      if (this.selected_email == null) {
        this.snackbar = true;
      } else {
        this.adding_to_izlazna = true;
        var tl = gsap.timeline();
        gsap.to("#svg-spin-izlazna", 0, { display: "flex" });
        gsap.to("#button-text-span-izlazna", 0, { display: "none", opacity: 0 });
        gsap.to("#add-to-izlazna", 0, { display: "block", opacity: 1 });
        //umjesto ovog timeouta postaviti zvati neku funkciju za dodavanje
        //u spis i u then kopirati sve kaj je u timeoutu
        let tmp_mail = this.selected_email;
        tmp_mail["attachment_text"] = ""
        if (this.listed_attachments.length > 0) {
          tmp_mail["attachment_text"] = "<b>" + this.$t("components.pregled_poste.header.t5") + ": </b>" + this.attachmentList(this.listed_attachments);
        }
        ms_email
          .saveEmail(
            this.accessToken,
            this.email_id,
            this.$route.params.uid,
            this.izlaz,
            this.select_page_limit,
            tmp_mail
          )
          .then(() => {
            this.dodaj_izlazna_text = this.$t("components.pregled_poste.added_btn");
          })
          .catch((err) => {
            this.dodaj_izlazna_text = this.$t("components.pregled_poste.err_btn")
            console.log(err)
          })
          .finally(() => {
            gsap.to("#add-to-izlazna", 0, { display: "none", opacity: 0 });
            gsap.to("#svg-spin-izlazna", 0, { display: "none" });

            gsap.to("#button-text-span-izlazna", 0.3, {
              display: "block",
              opacity: 1,
            });
            setTimeout(() => {
              this.select_page_limit = 0;
              this.dodaj_izlazna_text = this.$t("components.pregled_poste.btn_3");
              this.adding_to_izlazna = false;
              this.$emit("refresh-view", true);
            }, 1200);
          });
      }
    },
    radniMailToPDF() {
      this.snackbar = false;
      if (this.selected_email == null) {
        this.snackbar = true;
      } else {
        this.adding_to_radni = true;
        var tl = gsap.timeline();
        gsap.to("#svg-spin-radni-email", 0, { display: "flex" });
        gsap.to("#button-text-span-radni-email", 0, { display: "none", opacity: 0 });
        gsap.to("#add-to-radni-email", 0, { display: "block", opacity: 1 });
        //umjesto ovog timeouta postaviti zvati neku funkciju za dodavanje
        //u spis i u then kopirati sve kaj je u timeoutu
        let tmp_mail = this.selected_email;
        tmp_mail["attachment_text"] = ""
        if (this.listed_attachments.length > 0) {
          tmp_mail["attachment_text"] = "<b>" + this.$t("components.pregled_poste.header.t5") + ": </b>" + this.attachmentList(this.listed_attachments);
        }
        ms_email
          .saveEmail(
            this.accessToken,
            this.email_id,
            this.$route.params.uid,
            this.radni_id,
            this.select_page_limit,
            tmp_mail
          )
          .then(() => {
            this.dodaj_radna_text = this.$t("components.pregled_poste.added_btn");
          })
          .catch((err) => {
            this.dodaj_radna_text = this.$t("components.pregled_poste.err_btn")
            console.log(err)
          })
          .finally(() => {
            gsap.to("#add-to-radni-email", 0, { display: "none", opacity: 0 });
            gsap.to("#svg-spin-radni-email", 0, { display: "none" });

            gsap.to("#button-text-span-radni-email", 0.3, {
              display: "block",
              opacity: 1,
            });
            setTimeout(() => {
              this.select_page_limit = 0;
              this.dodaj_radna_text = this.$t("components.pregled_poste.btn_5");
              this.adding_to_radni = false;
              this.$emit("refresh-view", true);
            }, 1200);
          });
      }
    },
    outAttachmentToPDF() {
      this.handleAttachmentToPDF(this.$route.params.uid, this.izlaz);
    },
    //JEBENO SMECE OD VUETIFYJA
    //NEBRE POSTAVITI KLASU NA TAJ USRANI V-DIALOG PA MORA NA OVAJ MUTAVI NACIN
    addFuckingClass() {
      setTimeout(() => {
        var getFuckingParent = document.getElementById("email-catcher");
        $(getFuckingParent.parentElement.parentElement).addClass("email-popup");
      }, 100);
    },



    async handleAttachmentToPDF(case_id, fold_id) {
      if (!fold_id) {
        alert(this.$t("upload_popup.choose_folder"));
        return;
      }
      switchGlobalLoaderState(this.$t("components.file_management.sharepointUpload.uploading"));
      let uploaded = false;
      try {
        // Archived cases: route through backend which uses app token
        if (window.location.href.includes('archived-case')) {
          await ms_email.saveEmailAttachment(
            "",
            this.email_id,
            case_id,
            fold_id,
            this.selected_attachment,
            true
          );
          uploaded = true;
        } else {
          const selected_folder = await this.getFileById(fold_id);
          const resp = await fileFinalization([this.selected_attachment], case_id, selected_folder);
          uploaded = resp.failed.length === 0 && resp.success.length > 0;
        }
      } catch (err) {
        console.error("Error saving attachment:", err);
      }
      this.finishAttachmentUpload(uploaded);
    },
    async handleAttachmentDirect(case_id, fold_id) {
      if (!fold_id) {
        alert(this.$t("upload_popup.choose_folder"));
        return;
      }
      switchGlobalLoaderState(this.$t("components.file_management.sharepointUpload.uploading"));
      let uploaded = false;
      try {
        // Archived cases: route through backend which uses app token
        if (window.location.href.includes('archived-case')) {
          await ms_email.saveEmailAttachment(
            "",
            this.email_id,
            case_id,
            fold_id,
            this.selected_attachment,
            false
          );
          uploaded = true;
        } else {
          const resp = await fileDirectUpload([this.selected_attachment], case_id, { id: fold_id });
          uploaded = resp.failed.length === 0 && resp.success.length > 0;
        }
      } catch (err) {
        console.error("Error saving attachment:", err);
      }
      this.finishAttachmentUpload(uploaded);
    },
    // Only report success when the file actually landed in SharePoint.
    finishAttachmentUpload(uploaded) {
      if (uploaded) {
        switchGlobalLoaderMessage(this.$t("components.file_management.sharepointUpload.success"));
        this.$emit("refresh-view", true);
        setTimeout(() => { switchGlobalLoaderState(); }, 2000);
      } else {
        switchGlobalLoaderState();
        alert(this.$t("components.file_management.sharepointUpload.error", { files: this.selected_attachment.name }));
      }
    },
    async getFileById(sid) {
      let tmp_file = null;
      await graph
        .getSingleFile(this.$route.params.uid, sid)
        .then(async (response) => {
          tmp_file = response;
          console.log(tmp_file);
        });
      return tmp_file;
    },       
  },
  watch: {
    fold_type: function () {
      this.skip = 0;
      this.next_link = null;
      this.emails = [];
      this.selected_email = null;
      this.email_id = null;
      this.current = -1;
      this.getEmails();
    },
    date_range: function () {
      this.skip = 0;
      this.next_link = null;
      this.emails = [];
      this.selected_email = null;
      this.email_id = null;
      this.current = -1;
      this.getEmails();
    },
    selected_type: function () {
      this.skip = 0;
      this.srch_txt = "";
      this.next_link = null;
      this.emails = [];
      this.date_range = [];
      this.selected_email = null;
      this.email_id = null;
      this.current = -1;
      this.getEmails();
    },
    srch_txt: function () {
      if (this.srch_txt == null && this.selected_type == 2) {
        this.searchByText();
      }
    }

  },
  async created() {
    if (this.$route.name == "Posta") {
      await getCaseData(this.$route.params.uid).then(async (response) => {
        response.spis.map((spis) =>
          this.spisi.push({ naziv: spis.ime, id: spis.id_spis })
        );
      });
    }

  },
  mounted() {
    this.getEmails();
    
  },

};
</script>